if (!window.customElements.get('product-tab-features-video')) {
  window.customElements.define(
    'product-tab-features-video',
    class extends HTMLElement {
      constructor() {
        super();

        this.firstInit();
      }

      firstInit() {
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          this.appendChild(content.querySelector('video, model-viewer, iframe'));
        }
      }

      play() {
        this.querySelector('video')?.play();
      }

      stop() {
        const video = this.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }
  );
}

if (!window.customElements.get('product-tab-features')) {
  window.customElements.define(
    'product-tab-features',
    class extends HTMLElement {
      /** @type {HTMLElement} */
      previousTabButton;
      /** @type {HTMLElement} */
      previousMediaElement;

      constructor() {
        super();
        this.swiperElement = this.querySelector('.swiper');
        this.featuredWrapper = this.querySelector('.product-tab-features__featured-wrapper');
        this.mediaWrapper = this.querySelector('.product-tab-features__media-wrapper');
        this.pointList = this.querySelector('.product-tab-features__point-list');
        this.tabItems = [...this.querySelectorAll('[data-tab-for]')];
        this.previousTabButton = this.querySelector('[data-tab-for][open]>button');
        this.animating = false;
        this.animationDuration = 300;

        this.isMobileMQL = window.matchMedia(`(max-width: 767px)`);
        this.isMobileMQL.addEventListener('change', (event) => {
          if (this.mySwiper) this.destroySwiper();
          if (!event.matches) {
            this.createSwiper();
          }
        });
        if (!this.isMobileMQL.matches) this.createSwiper();
        setTimeout(() => {
          this.firstInit();
        }, 0);
      }

      firstInit() {
        const isMobile = this.isMobileMQL.matches;
        if (isMobile) {
          const video = this.querySelector('[data-tab-for][open] + [data-features-media-mobile] product-tab-features-video');
          video?.play();
          this.previousMediaElement = video;
        } else {
          const video = this.querySelector('[data-tab-content="0"] product-tab-features-video');
          video?.play();
          this.previousMediaElement = video;
        }
      }

      connectedCallback() {
        this.addEventListener('click', (e) => {
          /** @type {HTMLElement} */
          const button = e.target.closest('[data-tab-for] button');
          if (button) {
            this.handleClickTabButton(button);
          }
        });
      }

      createSwiper() {
        this.mySwiper = new Swiper(this.swiperElement, {
          effect: 'fade',
          slidesPerView: 1,
          // autoHeight: true,
          observer: true,
          resizeObserver: true,
          allowTouchMove: false,
        });
      }

      destroySwiper() {
        this.mySwiper.destroy();
      }

      /**
       * 点击 Tab 切换
       * @param {HTMLElement} button
       */
      handleClickTabButton(button) {
        if (this.animating) return;

        const isMobile = this.isMobileMQL.matches;
        if (button === this.previousTabButton) return;

        const tab = button.parentElement;
        const previousTab = this.previousTabButton?.parentElement;
        const index = Number(tab.getAttribute('data-tab-for'));

        if (isNaN(index)) {
          console.error('<product-tab-features>: slide index is NaN');
          return;
        }

        this.animating = true;
        const listWidth = this.pointList.getBoundingClientRect().width;

        const animationPromise =
          previousTab && previousTab !== tab
            ? this.animateSwitchTab(previousTab, tab, listWidth, index, isMobile)
            : this.animateExpand(tab, listWidth, index, isMobile);

        animationPromise.then(() => {
          this.previousTabButton = button;
          this.animating = false;
        });
      }

      /** 切换视频 / Swiper，与宽度并行动画同步 */
      switchTabMedia(tab, index, isMobile) {
        if (isMobile) {
          const mediaElement = this.getMobileMedia(tab)?.querySelector('product-tab-features-video');
          this.previousMediaElement?.stop();
          this.previousMediaElement = mediaElement;
          mediaElement?.play();
        } else {
          this.mySwiper.slideTo(index);
          const mediaElement = this.mediaWrapper.querySelector(`[data-tab-content="${index}"] product-tab-features-video`);
          this.previousMediaElement?.stop();
          this.previousMediaElement = mediaElement;
          mediaElement?.play();
        }
      }

      /** 获取 Tab 对应的移动端 media 元素 */
      getMobileMedia(tab) {
        const media = tab.nextElementSibling;
        return media?.matches('[data-features-media-mobile]') ? media : null;
      }

      /** 测量移动端 media 完整高度 */
      measureMobileMediaHeight(mediaEl) {
        const saved = {
          height: mediaEl.style.height,
          overflow: mediaEl.style.overflow,
        };

        mediaEl.style.height = 'auto';
        mediaEl.style.overflow = 'hidden';
        const { height } = this.getRectSize(mediaEl);
        mediaEl.style.height = saved.height;
        mediaEl.style.overflow = saved.overflow;

        return height;
      }

      /** Tab 与移动端 media 同步高度动画 */
      animateHeightPair(tab, tabHeight, mobileMedia, mediaHeight, duration) {
        const animations = [this.animateStyle(tab, 'height', `${tabHeight}px`, duration)];

        if (mobileMedia) {
          animations.push(this.animateStyle(mobileMedia, 'height', `${mediaHeight}px`, duration));
        }

        return Promise.all(animations);
      }

      /** 动画结束后移除移动端 media 的 inline 尺寸 */
      clearMobileMediaAnimationStyles(mediaEl) {
        if (!mediaEl) return;
        mediaEl.style.transition = '';
        mediaEl.style.height = '';
        mediaEl.style.overflow = '';
      }

      /** 获取亚像素精度尺寸，避免取整导致文字换行 */
      getRectSize(element) {
        const { width, height } = element.getBoundingClientRect();
        return { width, height };
      }

      /**
       * Tab 切换动画：旧 Tab 缩高 → 旧 Tab 缩宽 + 新 Tab 变宽（并行，同时切媒体）→ 新 Tab 变高
       */
      animateSwitchTab(previousTab, tab, listWidth, index, isMobile) {
        const duration = this.animationDuration;
        const expand = tab.querySelector('.product-tab-features__point-expand');
        const collapsedSize = this.getCollapsedTabSize(previousTab);
        const { height: prevHeight } = this.getRectSize(previousTab);
        const { width: tabStartWidth, height: tabStartHeight } = this.getRectSize(tab);
        const prevMobileMedia = isMobile ? this.getMobileMedia(previousTab) : null;
        const tabMobileMedia = isMobile ? this.getMobileMedia(tab) : null;
        const prevMediaHeight = prevMobileMedia ? this.getRectSize(prevMobileMedia).height : 0;

        previousTab.style.overflow = 'hidden';
        previousTab.style.width = `${listWidth}px`;
        previousTab.style.height = `${prevHeight}px`;

        tab.style.overflow = 'hidden';
        tab.style.width = `${tabStartWidth}px`;
        tab.style.height = `${tabStartHeight}px`;

        if (prevMobileMedia) {
          prevMobileMedia.style.overflow = 'hidden';
          prevMobileMedia.style.height = `${prevMediaHeight}px`;
        }

        return this.animateHeightPair(previousTab, collapsedSize.height, prevMobileMedia, 0, duration)
          .then(() => {
            previousTab.removeAttribute('open');
            this.clearMobileMediaAnimationStyles(prevMobileMedia);

            // 宽度并行动画开始时切换媒体
            this.switchTabMedia(tab, index, isMobile);

            return Promise.all([
              this.animateStyle(previousTab, 'width', `${collapsedSize.width}px`, duration),
              this.animateStyle(tab, 'width', `${listWidth}px`, duration),
            ]);
          })
          .then(() => {
            this.clearTabAnimationStyles(previousTab);

            tab.setAttribute('open', '');
            expand.style.width = '100%';
            expand.style.height = 'auto';
            tab.style.height = `${tabStartHeight}px`;

            const fullHeight = this.measureTabFullHeight(tab, listWidth);
            const mediaFullHeight = tabMobileMedia ? this.measureMobileMediaHeight(tabMobileMedia) : 0;

            if (tabMobileMedia) {
              tabMobileMedia.style.overflow = 'hidden';
              tabMobileMedia.style.height = '0px';
            }

            return this.animateHeightPair(tab, fullHeight, tabMobileMedia, mediaFullHeight, duration);
          })
          .then(() => {
            this.clearTabAnimationStyles(tab);
            this.clearMobileMediaAnimationStyles(tabMobileMedia);
            expand.style.width = '';
            expand.style.height = '';
          });
      }

      /** 无旧 Tab 时直接展开：变宽 → 变高 */
      animateExpand(tab, listWidth, index, isMobile) {
        const duration = this.animationDuration;
        const expand = tab.querySelector('.product-tab-features__point-expand');
        const { width: startWidth, height: startHeight } = this.getRectSize(tab);
        const tabMobileMedia = isMobile ? this.getMobileMedia(tab) : null;

        tab.style.overflow = 'hidden';
        tab.style.width = `${startWidth}px`;
        tab.style.height = `${startHeight}px`;

        this.switchTabMedia(tab, index, isMobile);

        return this.animateStyle(tab, 'width', `${listWidth}px`, duration)
          .then(() => {
            tab.setAttribute('open', '');
            expand.style.width = '100%';
            expand.style.height = 'auto';
            tab.style.height = `${startHeight}px`;

            const fullHeight = this.measureTabFullHeight(tab, listWidth);
            const mediaFullHeight = tabMobileMedia ? this.measureMobileMediaHeight(tabMobileMedia) : 0;

            if (tabMobileMedia) {
              tabMobileMedia.style.overflow = 'hidden';
              tabMobileMedia.style.height = '0px';
            }

            return this.animateHeightPair(tab, fullHeight, tabMobileMedia, mediaFullHeight, duration);
          })
          .then(() => {
            this.clearTabAnimationStyles(tab);
            this.clearMobileMediaAnimationStyles(tabMobileMedia);
            expand.style.width = '';
            expand.style.height = '';
          });
      }

      /** 动画结束后移除 inline 尺寸，交还 CSS 响应式 */
      clearTabAnimationStyles(tab) {
        tab.style.transition = '';
        tab.style.width = '';
        tab.style.height = '';
        tab.style.overflow = '';
      }

      /** 临时展开内容区域，测量完整高度 */
      measureTabFullHeight(tab, listWidth) {
        const expand = tab.querySelector('.product-tab-features__point-expand');
        const saved = {
          tabWidth: tab.style.width,
          tabHeight: tab.style.height,
          expandWidth: expand.style.width,
          expandHeight: expand.style.height,
        };

        tab.style.width = `${listWidth}px`;
        tab.style.height = 'auto';
        expand.style.width = '100%';
        expand.style.height = 'auto';

        const { height } = this.getRectSize(tab);

        tab.style.width = saved.tabWidth;
        tab.style.height = saved.tabHeight;
        expand.style.width = saved.expandWidth;
        expand.style.height = saved.expandHeight;

        return height;
      }

      /** 隐藏 expand 后测量收起态尺寸（无 [open]，含完整 button 内边距） */
      getCollapsedTabSize(tab) {
        const expand = tab.querySelector('.product-tab-features__point-expand');
        const wasOpen = tab.hasAttribute('open');
        const saved = {
          tabWidth: tab.style.width,
          expandWidth: expand.style.width,
          expandHeight: expand.style.height,
        };

        if (wasOpen) tab.removeAttribute('open');
        expand.style.width = '0';
        expand.style.height = '0';
        tab.style.width = 'fit-content';

        const size = this.getRectSize(tab);

        tab.style.width = saved.tabWidth;
        expand.style.width = saved.expandWidth;
        expand.style.height = saved.expandHeight;
        if (wasOpen) tab.setAttribute('open', '');

        return size;
      }

      /** 单属性 CSS 过渡，完成后清除 transition */
      animateStyle(element, property, value, duration) {
        return new Promise((resolve) => {
          let resolved = false;
          const finish = () => {
            if (resolved) return;
            resolved = true;
            element.removeEventListener('transitionend', onTransitionEnd);
            element.style.transition = '';
            resolve();
          };
          const onTransitionEnd = (event) => {
            if (event.target === element && event.propertyName === property) {
              finish();
            }
          };

          element.style.transition = 'none';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              element.addEventListener('transitionend', onTransitionEnd);
              element.style.transition = `${property} ${duration}ms`;
              element.style[property] = value;
              setTimeout(finish, duration + 50);
            });
          });
        });
      }
    }
  );
}